'use client';

import { useCallback } from 'react';
import { useGetShippingPolicy } from './useGetShippingPolicy';

export const useGetAmountToFreeShipping = () => {
  const { shippingPolicy } = useGetShippingPolicy();

  const getAmountToFreeShipping = useCallback(
    (currentPrice: number) => {
      const freeShippingThreshold = shippingPolicy?.freeShippingThreshold ?? 1;

      const amountPrice = freeShippingThreshold - currentPrice;

      if (amountPrice > 0) {
        return amountPrice;
      }
      return 0;
    },
    [shippingPolicy],
  );

  return { getAmountToFreeShipping };
};
